import React from "react";
import Modal from "react-modal";

const ConfirmModal = ({
  title = "Confirm Action",
  content = "Are you sure you want to proceed?",
  isOpen,
  onRequestClose,
  onConfirm,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-dialog modal-dialog-centered"
      style={{
        overlay: {
          position: "fixed",
          zIndex: 99,
          backgroundColor: "rgba(0, 0, 0, 0.6)",
        },
        content: {},
      }}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{title}</h5>
          <button type="button" className="close" onClick={onRequestClose}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{content}</div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onRequestClose}
          >
            Cancel
          </button>
          <button type="button" className="btn btn-primary" onClick={onConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
